
import React from "react";
import ReactDOM from "react-dom";
import { Doughnut } from "react-chartjs-2";

export class Widget2 extends React.Component {
  render() {

    let dataWidget2 = this.props.dataWidget2;

    let data = {

      labels: ["Mahasiswa Sarjana", "Mahasiswa Sarjana Terapan", "Mahasiswa Diploma"],
      datasets: [
        {
          data: dataWidget2,
            dataPoints: [
          { label: "A", y: 71 },
          { label: "B", y: 55 },
          { label: "C", y: 50 },
          { label: "D", y: 65 }
        ],
          backgroundColor: [
            "rgb(46, 134, 193)",
            "rgb(255, 195, 0)",
            "rgb(26, 188, 156)",
          ],
          hoverOffset: 4
        }
      ],
    
      text: ""
    };

    return (
      <div>
        <Doughnut
          data={data}
            options={{

            legend: { display: true },
            elements: {
                center: {
                text: "CASE ENTERED 15K",
                color: "#1f4e56", // Default is #000000
                fontStyle: "Arial", // Default is Arial
                // sidePadding: 20, // Default is 20 (as a percentage)
                // minFontSize: 19, // Default is 20 (in px), set to false and text will not wrap.
                // lineHeight: 30 // Default is 25 (in px), used for when text wraps
                }
            }
            }}
        />
      </div>
    );
  }
}

ReactDOM.render(<Widget2 />, document.getElementById("root"));